import { DropdownButtonType,List, ListItem, SingleSelectDropdown } from '@tableau/widgets';
import React from 'react';

import { Messages } from '~src/codegen/Localize';
import { FieldArrayRenderProps } from '~src/settings/FormikWrapperForStubbing';
import { IRemoteQueryAgent } from '~src/settings/types/ISiteAdminBridgeSettings';
import { FeatureFlags } from '~src/ts/FeatureFlags';

export function BridgeRemoteAgentsPoolCell(agent: IRemoteQueryAgent, index: number, arrayHelpers: FieldArrayRenderProps, isDefaultPool: boolean) {
  return <>
    {!FeatureFlags.edgeMultiPoolEnabled &&
      <td>
        <span data-tb-test-id={'agent-pool-cell'}>
          {renderPooledDropDown(agent, index, arrayHelpers)}
        </span>
      </td>
    }
  </>;
}

function renderPooledDropDown(agent: IRemoteQueryAgent, index: number, arrayHelpers: FieldArrayRenderProps) {
  const pooledListItem: ListItem = { value: Messages.siteRemoteAgentPoolNameDefault() };
  const notPooledListItem: ListItem = { value: Messages.siteRemoteAgentPoolNameNotAvailable() };
  const myItems: ListItem[] = [pooledListItem, notPooledListItem];

  return (
    <SingleSelectDropdown
      list={<List items={myItems} />}
      type={DropdownButtonType.Outline}
      value={agent.pooled ? pooledListItem.value : notPooledListItem.value}
      onChange={(value: string) => {
        arrayHelpers.replace(index, { ...agent, pooled: value === pooledListItem.value });
      }}
      label=''
      testId={'agent-pool-dropdown'}
    />
  );
}